import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import { ProjectService } from 'src/app/services/project.service';
import { TaskService } from 'src/app/services/task.service';

@Component({
  selector: 'app-new-progress-report',
  templateUrl: './new-progress-report.component.html',
  styleUrls: ['./new-progress-report.component.scss']
})
export class NewProgressReportComponent implements OnInit {

  @Input() popupComments = false;
  @Input() projectid = 0;
  @Output() onmodalhidden = new EventEmitter<any>();
  @Output() onsubmit = new EventEmitter<any>();

  hasproject = false;
  cancelButton: any;
  saveButton: any;

  private _info: any;

  @Input('info')
  set info(info: any) {
    this._info = info;

    if (this.formProgressReport && info) {
      this.formProgressReport.get('id').setValue(info.id);
      this.formProgressReport.get('projectid').setValue(info.projectid);
      this.formProgressReport.get('pdescription').setValue(info.pdescription);
      this.hasproject = true;
    }
    // if (info && info.infoid > 0)
    // this.setinfoInfo(info);
  }

  formProgressReport: FormGroup = new FormGroup({
    createdbyid: new FormControl('', []),
    pdescription: new FormControl('', []),
    projectid: new FormControl(this.projectid, []),
    id: new FormControl(0, [])
  });
  projectslist: any;

  constructor(
    private projectService: ProjectService,
    private taskService: TaskService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.cancelButton = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupComments = false;
        this.close();
      },
    };

    this.saveButton = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.addNewComment();
      },
    };

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  updateProjectInfo(ev) {
    console.log(ev);
    if(ev.selectedItem)
      this.formProgressReport.get('projectid').setValue(ev.selectedItem.ID);
    else
    this.formProgressReport.get('projectid').setValue(0);
  }

  close() {
    this.popupComments = false;
    this.onmodalhidden.emit();
    this.initForm();
    this.hasproject = false;
  }

  initForm() {
    this.formProgressReport = new FormGroup({
      createdbyid: new FormControl('', []),
      pdescription: new FormControl('', []),
      projectid: new FormControl(0, []),
      id: new FormControl(0, [])
    });

  }

  //Progress Report
  addNewComment(){
    let form = this.formProgressReport.value;
    // form.projectid = this.projectid;

    if (!form.projectid || form.projectid ==0) {
      this.toast.warning('Please select project');
      return;
    }

    form.createdbyid = localStorage.getItem('customerid');
    this.projectService.InsertProgressReport(form).subscribe(result=>{
      this.toast.success('The Report has been updated successfully');
      this.popupComments = false;
      this.onsubmit.emit();
      // this.getProgressReport();
    })
  }

}
